<template>
    <div>
        <!-- WEB -->
            <div style class="d-none d-sm-block">
              <!-- FIXED -->
              <div style="position:fixed;width:18vw;">
                <!-- LEFT -->
                <img
                  src="@/static/photo/taufik2.jpg"
                  v-viewer
                  class="kinoLightBox img-thumbnail img-fluid animate__animated animate__bounceIn cursor-pointer text-center mx-auto animate__delay-1s"
                  style="z-index:20;height:150px;width:150px;border-radius:50%;"
                />
                <br />
                <!-- LEFT -->
                <img
                  v-show="menu"
                  src="@/static/vine.png"
                  class="kinoLightBox animate__animated animate__jackInTheBox"
                  style="position:absolute;left:10px;top:150px;height:220px;width:65px;z-index:5;"
                />
                <button
                  type="button"
                  @click="buka"
                  class="btn btn-sm btn-style9"
                  :style="`${$store.state.data.layout?$store.state.data.layout.button_color:''}`"
                  style="padding:1px;position:absolute;z-index:30;left:10px;"
                >
                  <img src="https://upload.egov.balangankab.go.id/svg/arrow-unsorted.svg" 
             class="d-inline" style="height:20px;width:20px;filter: brightness(0) invert(1);" alt="">
                </button>
                <div
                  class=" p-2 rounded-lg shadow-lg animate__animated animate__jackInTheBox"
                  v-show="menu"
                >
                <router-link to="/a-1/">
                  <button
                    type="button"
                    class="btn btn-sm btn-style9 btn-block"
                    :style="`${$store.state.data.layout?$store.state.data.layout.button_color:''}`"
                    style=""
                  >
                    About Me
                      <img src="https://upload.egov.balangankab.go.id/svg/user.svg" 
             class="d-inline" style="height:20px;width:20px;filter: brightness(0) invert(1);" alt="">
                  </button>
                </router-link>
                <router-link to="/a-1/portofolio">
                <button
                    type="button"
                    class="btn btn-sm btn-style9 btn-block"
                    :style="`${$store.state.data.layout?$store.state.data.layout.button_color:''}`"
                    style=""
                  >
                    Portofolio
                           <img src="https://upload.egov.balangankab.go.id/svg/news.svg" 
             class="d-inline" style="height:20px;width:20px;filter: brightness(0) invert(1);" alt="">
                  </button>
                </router-link>
                <router-link to="/a-1/contact">
                  <button
                    type="button"
                    class="btn btn-sm btn-style9 btn-block"
                    :style="`${$store.state.data.layout?$store.state.data.layout.button_color:''}`"
                    style=""
                  >
                    Contact
                           <img src="https://upload.egov.balangankab.go.id/svg/clipboard.svg" 
             class="d-inline" style="height:20px;width:20px;filter: brightness(0) invert(1);" alt="">
                  </button>
                </router-link>
                <router-link to="/a-1/project">
                  <button
                    type="button"
                    class="btn btn-sm btn-style9 btn-block"
                    :style="`${$store.state.data.layout?$store.state.data.layout.button_color:''}`"
                    style=""
                  >
                    My Projects
                            <img src="https://upload.egov.balangankab.go.id/svg/anchor.svg" 
             class="d-inline" style="height:20px;width:20px;filter: brightness(0) invert(1);" alt="">
                   
                  </button>
                </router-link>
                <router-link to="/a-1/sertifikat">
                  <button
                    type="button"
                    class="btn btn-sm btn-style9 btn-block"
                    :style="`${$store.state.data.layout?$store.state.data.layout.button_color:''}`"
                    style=""
                  >
                    My Certificates
                      <img src="https://upload.egov.balangankab.go.id/svg/bookmark.svg" 
             class="d-inline" style="height:20px;width:20px;filter: brightness(0) invert(1);" alt="">
                  </button>
                </router-link>
                <!-- <router-link to="/a-1/coffe">
                <button
                    type="button"
                    class="btn btn-sm btn-style9 btn-block"
                    :style="`${$store.state.data.layout?$store.state.data.layout.button_color:''}`"
                    style=""
                  >
                    Buy me a Coffe !
                       <img src="https://upload.egov.balangankab.go.id/svg/coffee.svg" 
             class="d-inline" style="height:20px;width:20px;filter: brightness(0) invert(1);" alt="">
                  </button>
                </router-link> -->
                </div>
              </div>
              <!-- FIXED -->
            </div>
            <!-- MOBILE -->
            <div class="d-block d-sm-none">
              <!-- LEFT -->
              <img
                src="@/static/photo/taufik2.jpg"
                v-viewer
                class="kinoLightBox img-thumbnail img-fluid animate__animated animate__bounceIn cursor-pointer text-center mx-auto animate__delay-1s"
                style="z-index:20;height:150px;width:150px;border-radius:50%;"
              />
              <br />
              <!-- LEFT -->
              <img
                v-show="menu"
                src="@/static/vine.png"
                class="kinoLightBox animate__animated animate__jackInTheBox"
                style="position:absolute;left:10px;top:150px;height:220px;width:65px;z-index:5;"
              />
              <button
                type="button"
                @click="buka"
                class="btn btn-sm btn-style9"
                :style="`${$store.state.data.layout?$store.state.data.layout.button_color:''}`"
                style="padding:1px;position:absolute;z-index:30;left:10px;"
              >
                <span class="typcn typcn-arrow-unsorted"></span>
              </button>
              <div
                class=" p-2 rounded-lg shadow-lg animate__animated animate__jackInTheBox"
                v-show="menu"
              >
              <router-link to="/a-1/">
                <button
                  type="button"
                  class="btn btn-sm btn-style9 btn-block"
                  :style="`${$store.state.data.layout?$store.state.data.layout.button_color:''}`"
                  style=""
                >
                  About Me
                  <span class="float-right typcn typcn-user"></span>
                </button>
              </router-link>
              <router-link to="/a-1/portofolio">
              <button
                  type="button"
                  class="btn btn-sm btn-style9 btn-block"
                  :style="`${$store.state.data.layout?$store.state.data.layout.button_color:''}`"
                  style=""
                >
                  Portofolio
                  <span class="float-right typcn typcn-news"></span>
                </button>
              </router-link>
              <router-link to="/a-1/contact">
                <button
                  type="button"
                  class="btn btn-sm btn-style9 btn-block"
                  :style="`${$store.state.data.layout?$store.state.data.layout.button_color:''}`"
                  style=""
                >
                  Contact
                  <span class="float-right typcn typcn-clipboard"></span>
                </button>
              </router-link>
              <router-link to="/a-1/project">
                <button
                  type="button"
                  class="btn btn-sm btn-style9 btn-block"
                  :style="`${$store.state.data.layout?$store.state.data.layout.button_color:''}`"
                  style=""
                >
                  My Projects
                  <span class="float-right typcn typcn-anchor"></span>
                </button>
              </router-link>
              <router-link to="/a-1/sertifikat">
                <button
                  type="button"
                  class="btn btn-sm btn-style9 btn-block"
                  :style="`${$store.state.data.layout?$store.state.data.layout.button_color:''}`"
                  style=""
                >
                  My Certificates
                  <span class="float-right typcn typcn-bookmark"></span>
                </button>
              </router-link>
              <!-- <router-link to="/a-1/coffe">
                <button
                  type="button"
                  class="btn btn-sm btn-style9 btn-block"
                  :style="`${$store.state.data.layout?$store.state.data.layout.button_color:''}`"
                  style=""
                >
                  Buy me a Coffe !
                  <span class="float-right typcn typcn-coffee"></span>
                </button>
              </router-link> -->
              </div>
            </div>
            <!-- MOBILE -->
    </div>
</template>
<script>
export default{
  data () {
    return {
      menu: true,
      mdq: ''
    }
  },
  methods: {
    buka () {
      this.menu = !this.menu
    },
  },
}
</script>